import { matchPath } from 'react-router';

import { ROUTE_EDIT_DRAFT } from 'modules/editor/routes/constants';

const matcher = (pathname, route) => matchPath(pathname, route) !== null;

export const isEditorDraftRoute = (location) => matcher(location.pathname, ROUTE_EDIT_DRAFT);
